var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWlUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5 7.13872 5 6.20808 5.24472 5.45492C5.73931 3.93273 6.93273 2.73931 8.45492 2.24472C9.20808 2 10.1387 2 12 2C13.8613 2 14.7919 2 15.5451 2.24472C17.0673 2.73931 18.2607 3.93273 18.7553 5.45492C19 6.20808 19 7.13872 19 9V22L17.2063 20.4626C15.3585 18.8787 14.4345 18.0867 13.3984 17.7849C12.4851 17.5189 11.5149 17.5189 10.6016 17.7849C9.56547 18.0867 8.64154 18.8787 6.79367 20.4626L5 22V9Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlUnselected);
export default __webpack_public_path__ + "static/media/wl_unselected.6eb620ab433d64fba346814719d8578f.svg";
export { ForwardRef as ReactComponent };